import axios from "axios";

// OWL-2292: Saved Segments admin API.

export const getAll = () => {
    return axios.get("/api/services/app/Segment/GetAllForAdmin");
};

export const getById = (id) => {
    return axios.get("/api/services/app/Segment/Get", { params: { id } });
};

export const create = (segment) => {
    return axios.post("/api/services/app/Segment/Create", segment);
};

export const update = (segment) => {
    return axios.put("/api/services/app/Segment/Update", segment);
};

export const del = (id) => {
    return axios.delete("/api/services/app/Segment/Delete", { params: { id } });
};

// Preview evaluates arbitrary (possibly unsaved) criteria and returns the matching student count + sample.
export const preview = (criteria) => {
    return axios.post("/api/services/app/Segment/Preview", criteria);
};

// Option sources for the criteria builder (reused from the advisor form / caseload filters).
export const getAllSchools = () => {
    return axios.get("/api/services/app/School/GetAllActive");
};

export const getActiveSpecialGroups = () => {
    return axios.get("/api/services/app/SpecialGroup/GetActive");
};
